import { useTranslation } from "react-i18next";

import SignInSteps from "../components/SignInSteps/SignInSteps";

const SignIn = () => {
  const { t } = useTranslation("auth");

  return (
    <>
      <title>{`${t("signIn.signIn")} - Ximly`}</title>
      <SignInSteps />
    </>
  );
};

export default SignIn;
